<template>
<div style="background:#eee;overflow-x: hidden;">
    <BillQueryGrid ref="billqureygrid"  v-show="!showHead" :config="myConfig.billQueryConfig" :dictData="dictData" :moduleMethod="moduleMethod"  @doAction="doAction" />
    <BillDetailForm ref="form" v-show="showHead" :config="myConfig.detailConfig" :dictData="dictData" :moduleMethod="moduleMethod"  @doAction="doAction"/>
</div>
</template>

<script>
export default {
    name:'listdetails',
    data () {
        return {
            showHead:false,
            myConfig:{
                adjustHeight:105,
            },
            ph_key:''
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        }
    },
    created () {
        this.myConfig =  Object.assign({},this.myConfig, this.config);
        // 处理列表
        this.myConfig.billQueryConfig.resources = this.myConfig.resources;
        this.myConfig.billQueryConfig.classPrefix = this.myConfig.classPrefix;
        this.myConfig.billQueryConfig.response = this.myConfig.response;
        this.myConfig.billQueryConfig.gridConfig.tableSize ='small';
        this.myConfig.billQueryConfig.gridConfig.showBorder = false;
        this.myConfig.billQueryConfig.gridConfig.height = 1;
        this.myConfig.billQueryConfig.gridConfig.adjustHeight = 0;
        // 处理详情
        this.myConfig.detailConfig.titleType = 2;
        if (this.myConfig.detailConfig.showAnchorLink === undefined) {
            this.myConfig.detailConfig.showAnchorLink = false;
        }
        if (this.myConfig.detailConfig.showAnchorLink) {
            if (this.myConfig.detailConfig.anchorCol === undefined) {
                this.myConfig.detailConfig.anchorCol = 3;
            }
        }
        this.myConfig.detailConfig.adjustHeight = 0;
        this.myConfig.detailConfig.response = this.myConfig.response;
        this.myConfig.detailConfig.billisworkflow = this.myConfig.billisworkflow;
        this.myConfig.detailConfig.approvalConfig = {};
        this.myConfig.detailConfig.approvalConfig.response = this.myConfig.response;
        this.myConfig.detailConfig.approvalConfig.classPrefix = this.myConfig.classPrefix;
        this.myConfig.detailConfig.approvalConfig.resources = this.myConfig.resources;
        this.myConfig.detailConfig.approvalConfig.titleType = 2;
        this.myConfig.detailConfig.approvalConfig.hide = true;
        this.myConfig.detailConfig.approvalConfig.bordered = true;
        this.myConfig.detailConfig.approvalConfig.disHover = false;
        this.myConfig.detailConfig.approvalConfig.onOk = this.approvalOk;
      
        // 处理日志
        if (this.myConfig.showOperLog) {
            this.myConfig.detailConfig.showOperLog = true;
            if (this.myConfig.operLogKey) {
                this.myConfig.detailConfig.operLogKey = this.myConfig.operLogKey;
            }
        }
    
        this.myConfig.detailConfig.resources = this.myConfig.resources; 
        if (this.myConfig.detailConfig.billDetailConfig && this.myConfig.detailConfig.billDetailConfig.items) {
            this.myConfig.detailConfig.billDetailConfig.items.forEach(el => {
                el.tableSize = 'small';
                el.showBorder = false;
                el.hide = true;
                el.bordered = true;
                el.disHover = false;
                el.showCheckBox = false;
                el.showBorder = false;
            });
        }
    },
    methods:{
        doAction (obj) {
            if (obj.name === 'gridSelectionChange' ) {
                if (this.$parent[obj.name]) {
                    this.$parent[obj.name](obj);
                }
                return true;
            }
            const method = obj.name;
            const methodBefore = method + 'Before';
            const methodAfter = method + 'After';
            if (obj.name === 'skipData' || obj.name === 'gridDbClick' || obj.name === 'backData' || obj.name === 'searchData'
                || obj.name === 'editData' || obj.name === 'addData' || obj.name === 'preBill'  || obj.name === 'nextBill' || obj.name === 'resetData' ) {
                let flag =  true;
                if (this.$parent[methodBefore]) {
                    flag = this.$parent[methodBefore]();
                }
                if (flag) {
                    // '跳转'
                    if (obj.name === 'skipData' || obj.name === 'gridDbClick') {
                        this.initForm(obj.para, obj.name);
                    }
                    // 返回
                    if (obj.name === 'backData') {
                        let temp = {};
                        let self = this;
                        temp.onOk = () => {
                            self.$refs.billqureygrid.refurbish();
                            self.$nextTick(() => {
                                self.showHead = false;
                            });
                        };
                        this.checkData(temp);
                    }
                    // 查询
                    if (obj.name === 'searchData') {
                        this.$refs.billqureygrid.getQuick().filterSearch();
                        /*this.setPhkey('');
                        this.ph_key = '';
                        this.$refs.billqureygrid.refurbish();
                        */
                    } 
                    // 重置
                    if (obj.name === 'resetData') {
                        this.$refs.billqureygrid.getQuick().clearData();
                    }  

                    // 编辑
                    if (obj.name === 'editData') {
                        this.$refs.form.setReadOnly(false);
                        this.getMenuToolbar().setReadOnly('editData', true);
                        this.getMenuToolbar().setReadOnly('saveData', false);
                        this.showHead = true;
                    }
                    // 新增
                    if (obj.name === 'addData') {
                        this.$refs.form.setReadOnly(false);
                        this.$refs.form.clearData();
                        this.getMenuToolbar().setAllReadOnly(true);
                        this.getMenuToolbar().setReadOnly('saveData', false);
                        this.showHead = true;
                    }
                    // 上一单 
                    if (obj.name === 'preBill') {
                        this.preBill();
                    }
                    // 下一单 
                    if (obj.name === 'nextBill') {
                        this.nextBill();
                    }
    
                    if (this.$parent[methodAfter]) {
                        this.$parent[methodAfter]();
                    }
                }
            } else {
                let data = this.$refs.form.getData();
                if (obj.name === 'saveData') {
                    let flag = this.$refs.form.checkValidate();
                    if (flag) {
                        this.alert('必填项不允许为空');
                        return false;
                    }
                    flag = this.$refs.form.isEdit();
                    if (flag) {
                        this.alert('存在数据未确认');
                        return false; 
                    }
                    obj.para = this.$refs.form.getChangeData();
                } 
                if (obj.name === 'saveDetails') {
                    obj.para = this.$refs.form.getChangeData(obj.detailsname);
                    obj.name = 'saveData';
                } 
                if (obj.name === 'delData') {
                    if (this.showHead) {
                        obj.para = data;
                        obj.para.flag = 'D';
                    } else {
                        if (obj.para instanceof Array) {
                            obj.para.forEach(el => {
                                el.flag = 'D';
                            });
                        } else {
                            obj.para.flag = 'D';
                            let temp = [obj.para];
                            obj.para = temp;
                        }
                    }
                }  
                if (obj.name === 'copyData') {
                    obj.para ={ph_key:data.ph_key};
                }
                obj.onOk = this.onOk;
                if (obj.name === 'delData' || obj.name === 'auditData' || obj.name === 'cancelData' || obj.name === 'revokeData') {
                    let text = '删除';
                    if (obj.name === 'auditData') {
                        text = '审核';
                        obj.para ={billno:data.billno};
                    }
                    if (obj.name === 'cancelData') {
                        text = '作废';
                        obj.para ={billno:data.billno};
                    }
                   
                    if (obj.name === 'revokeData') {
                        text = '撤回';
                        obj.para ={billno:data.billno};
                    }
                    if (this.$parent.getActionName) {
                        let name = this.$parent.getActionName(obj);
                        if (name) {
                            text = name;
                        }
                    }   
                    let info = '确定是否' + text + '单据？';
                    let self = this;
                    self.$Modal.confirm({
                        title:'确认',
                        content: info,
                        onOk:() => {
                            self.$emit('doAction', obj);
                        }
                    });
                }  else {
                    this.$emit('doAction', obj);
                }
            }
        },
        setShowHead (value) {
            this.showHead = value;
            if (!this.showHead) {
                this.$refs.billqureygrid.refurbish();
            }
        },
        setAllAnchorVisible(value) {
            this.$refs.form.setAllAnchorVisible(value);
        },
        setAnchorVisible(obj, value) {
            this.$refs.form.setAnchorVisible(obj,value);
        },
        setRowBtnVisible(value) {
            this.$refs.form.setRowBtnVisible(value);
        },
        setPhkey(value) {
            this.ph_key = value;
            this.$refs.billqureygrid.setPhkey(value);
        },
        onOk (action, data) {
            if (action.name === 'saveData') {
                this.$refs.billqureygrid.setPhkey(data[0].ph_key);
                this.initForm(data[0], action.name);
            }
            if (action.name === 'delData') {
                this.ph_key = '';
                this.$refs.billqureygrid.setPhkey('');
                if (!this.showHead) {
                    this.$refs.billqureygrid.refurbish();
                }
                this.$refs.form.clearData();
                this.$refs.form.setReadOnly(true);
                this.getMenuToolbar().setAllReadOnly(true);
                this.getMenuToolbar().setReadOnly('addData', false);
            }
            if (action.name === 'auditData' || action.name === 'cancelData' || action.name === 'copyData' || action.name === 'submitData' || action.name === 'revokeData') {
                this.initForm({ph_key:this.ph_key},action.name);
            }
        },
        initForm(para,methodName) {
            this.$refs.form.clearData();
            let data = this.getFormData(para);
            if (data.ph_key) {
                this.ph_key = data.ph_key;
            } else {
                this.ph_key = '';
            }
            if (this.$parent.setBillData) {
                data = this.$parent.setBillData(data);
            }
            this.$refs.form.setData(data); 
            this.$nextTick(() => {
                this.$refs.form.setReadOnly(true);
            });
         
            if (methodName === 'skipData' || methodName === 'gridDbClick') {
                this.getMenuToolbar().setReadOnly('addData', false);
                this.getMenuToolbar().setReadOnly('saveData', true);
                  
            }
            if (methodName === 'saveData' || methodName === 'copyData' ) {
                this.getMenuToolbar().setReadOnly(['addData','delData','editData','auditData'], false);
                this.getMenuToolbar().setReadOnly('saveData', true);
            }
            if (methodName === 'auditData' || methodName === 'cancelData') {
                this.getMenuToolbar().setAllReadOnly(false);
                this.getMenuToolbar().setReadOnly(['delData','auditData','editData','saveData'], true);
            }

            if (this.$parent.initFormAfter) {
                this.$parent.initFormAfter(data);
            }

            if (this.myConfig.billisworkflow && this.myConfig.billisworkflow.startsWith('Y')) {
                let billstatus = 'N';
                if (this.myConfig.billwfstartflag) {
                    billstatus = this.myConfig.billwfstartflag;
                }
                this.getMenuToolbar().setVisible('auditData', false);
                if (data.billstatus === billstatus) {
                    this.getMenuToolbar().setReadOnly(['submitData'], false);
                    this.getMenuToolbar().setReadOnly(['revokeData','approveData'], true);
                } else {
                    this.getMenuToolbar().setReadOnly('submitData', true);
                    if (data.billstatus === 'S' || data.billstatus === 'A' || data.billstatus === 'M' || data.billstatus === 'R') {
                        if (data.billstatus === 'R') {
                            this.getMenuToolbar().setReadOnly('revokeData', false);
                            this.getMenuToolbar().setReadOnly('approveData', true);
                        } else if (data.billstatus === 'S') {
                            this.getMenuToolbar().setReadOnly('revokeData', false);
                            this.getMenuToolbar().setReadOnly('approveData', false);
                        } else {
                            this.getMenuToolbar().setReadOnly('revokeData', true);
                            this.getMenuToolbar().setReadOnly('approveData', false);
                        }
                    } else if (data.billstatus === 'Y') {
                        this.getMenuToolbar().setReadOnly(['submitData','revokeData','approveData'], true);
                    }
                }
            }
           
            
            if (this.myConfig.detailConfig.saveModel === 'part') {
                let index = this.moduleMethod.findIndex (el => el.name === 'editData');
                if (index > -1) {
                    let config = this.getMenuToolbar().getBtnConfig('editData');
                    if (config.readOnly) {
                        this.$refs.form.setEditVisible(false);
                    } else {
                        this.$refs.form.setEditVisible(true);
                    }
                    this.getMenuToolbar().setVisible('editData', false);
                } else {
                    this.$refs.form.setEditVisible(false);
                }
              
            } 
            this.showHead = true;
        },
        getMenuToolbar() {
            return this.$refs.form.getMenuToolbar();
        },
        getFormData (para) {
            let result = {};
            let self = this;
            if (!para.ph_key) {
                para.ph_key = this.ph_key;
            }
            self.synchroPost(self.myConfig.resources,self.myConfig.classPrefix+'.get', {ph_key:para.ph_key}, function (data) {
                result = data[self.config.response];
            });
            return result;
        },
        getForm() {
            return this.$refs.form;
        },
        getBillQureyGrid() {
            return this.$refs.billqureygrid;
        },
        preBill () {
            let data  = this.$refs.billqureygrid.getGrid().getData();
            if (this.ph_key) {
                let index = data.findIndex(el => el.ph_key === this.ph_key);
                if (index > -1) {
                    if (index === 0) {
                        this.initForm(data[data.length-1]);
                    } else {
                        this.initForm(data[index-1]);
                    }
                } else {
                    this.initForm(data[data.length-1]);
                }
            } else {
                this.initForm(data[data.length-1]);
            }
        },
        nextBill () {
            let data  = this.$refs.billqureygrid.getGrid().getData();
            if (this.ph_key) {
                let index = data.findIndex(el => el.ph_key === this.ph_key);
                if (index > -1) {
                    if (index === data.length-1) {
                        this.initForm(data[0]);
                    } else {
                        this.initForm(data[index+1]);
                    }
                } else {
                    this.initForm(data[0]);
                }
            } else {
                this.initForm(data[0]);
            }
        },
        approvalOk() {
            this.refurbish(this.ph_key);
        },
        refurbish (ph_key, acitonName) {
            if (ph_key) {
                this.ph_key = ph_key;
            } else {
                this.ph_key = '';
            }
            if (this.showHead) {
                if (this.ph_key) {
                    this.initForm({ph_key:this.ph_key},acitonName);
                }
            } else {
                this.setPhkey(this.ph_key);
                this.$refs.billqureygrid.refurbish();  
            }
           
        },
        checkData (obj) {
            let tempflag = false;
            tempflag = this.$refs.form.isEdit();
            if (tempflag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据存在数据未确认，是否放弃？',
                    onOk:() => {
                        this.checkChangeData(obj);
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                this.checkChangeData(obj);
            }
        },
        checkChangeData(obj) {
            let flag = false;
            flag = this.$refs.form.isChange();
            if (flag) {
                let self = this;
                self.$Modal.confirm({
                    title:'确认',
                    content:'单据有修改未保存，是否放弃修改？',
                    onOk:() => {
                        if (obj.onOk) {
                            obj.onOk();
                        }
                    },
                    onCancel:() => {
                        if (obj.onCancel) {
                            obj.onCancel();
                        }
                    }
                });
            } else {
                if (obj.onOk) {
                    obj.onOk();
                }
            }
        }
         

    },
    mounted () {
    
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouttemplate/listdetails.vue